module.exports = __webpack_public_path__ + "static/media/channel-mobile.bc309423.svg";